import { useAors } from 'hooks/useAors';
import { useAllIncidents } from 'components/IAP/hooks/incidentHooks';
import { PropertyRow } from './Layer';

export function RegionRow({ aorIds }: { aorIds: string[] }) {
  const { data: aors } = useAors();
  const names = aors
    ?.filter((aor) => aorIds.includes(aor.id))
    .map((aor) => aor.name)
    .join(', ');

  return <PropertyRow label="Region(s)" value={names} />;
}

export function IncidentRow({ incidentId }: { incidentId?: string | null }) {
  const { data: incidents = [] } = useAllIncidents();
  const name = incidents.find((i) => i.id === incidentId)?.name;

  return <PropertyRow label="Incident" value={name} />;
}

export function LayerMetadata({
  lastUpdated,
  aorIds,
  incident,
  sources,
}: {
  lastUpdated: string;
  aorIds: string[];
  incident?: string | null;
  sources: string;
}) {
  return (
    <>
      <PropertyRow label="Last Updated" value={lastUpdated} />
      <RegionRow aorIds={aorIds} />
      <IncidentRow incidentId={incident} />
      <PropertyRow label="Type" value="Data layer" />
      <PropertyRow label="Sources" value={sources} />
    </>
  );
}
